import { api } from '@/api';

export type PremexClosedResponse = Blob;

const premexClosedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPremexClosed: builder.query<PremexClosedResponse, void>({
      query: () => ({
        url: `debug/premex-closed`,
        method: 'GET',
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
        responseHandler: async (response) => {
          return await response.blob();
        },
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetPremexClosedQuery } = premexClosedApi;
